module.exports = __webpack_public_path__ + "static/media/check_icon.a0b9de13.svg";